import { render, staticRenderFns } from "./bottomLeft.vue?vue&type=template&id=28c247f9&scoped=true"
import script from "./bottomLeft.vue?vue&type=script&lang=js"
export * from "./bottomLeft.vue?vue&type=script&lang=js"
import style0 from "./bottomLeft.vue?vue&type=style&index=0&id=28c247f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c247f9",
  null
  
)

export default component.exports